/**
 * Preorder Countdown Timer
 * Integrated into event badge: "DRAW \u00B7 47D 4H"
 */
(function() {
  'use strict';

  function initPreorderTimers() {
    var badges = document.querySelectorAll('[data-preorder-end][data-badge-label]');
    for (var i = 0; i < badges.length; i++) {
      if (!badges[i].dataset.countdownInit) {
        initSingleTimer(badges[i]);
        badges[i].dataset.countdownInit = 'true';
      }
    }
  }

  function initSingleTimer(badgeEl) {
    var endDateStr = badgeEl.dataset.preorderEnd;
    var label = badgeEl.dataset.badgeLabel;
    if (!endDateStr || !label) return;

    // Supports: YYYYMMDD (8), YYYY-MM-DD (10), YYYYMMDDTHHmm (13) - all KST
    var endDate;
    if (/^\d{8}T\d{4}$/.test(endDateStr)) {
      var y = endDateStr.substring(0, 4), m = endDateStr.substring(4, 6), d = endDateStr.substring(6, 8);
      var h = endDateStr.substring(9, 11), mi = endDateStr.substring(11, 13);
      endDate = new Date(y + '-' + m + '-' + d + 'T' + h + ':' + mi + ':00+09:00');
    } else if (/^\d{8}$/.test(endDateStr)) {
      var y = endDateStr.substring(0, 4), m = endDateStr.substring(4, 6), d = endDateStr.substring(6, 8);
      endDate = new Date(y + '-' + m + '-' + d + 'T23:59:59+09:00');
    } else {
      endDate = new Date(endDateStr + 'T23:59:59+09:00');
    }
    if (isNaN(endDate.getTime())) return;

    function formatCompact(days, hours, mins) {
      if (days > 0) return days + 'D ' + hours + 'H';
      if (hours > 0) return hours + 'H ' + mins + 'M';
      return mins + 'M';
    }

    function updateCountdown() {
      var now = new Date();
      var diff = endDate - now;

      if (diff <= 0) {
        badgeEl.textContent = label + ' \u00B7 Ended';
        badgeEl.classList.add('badge--countdown--expired');
        return false;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);

      badgeEl.textContent = label + ' \u00B7 ' + formatCompact(days, hours, mins);
      return true;
    }

    var shouldContinue = updateCountdown();
    if (shouldContinue) {
      var interval = setInterval(function() {
        if (!updateCountdown()) clearInterval(interval);
      }, 60000);
    }
  }

  function observeNewTimers() {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            if (added[j].dataset && added[j].dataset.preorderEnd && added[j].dataset.badgeLabel) {
              initSingleTimer(added[j]);
            }
            var badges = added[j].querySelectorAll ? added[j].querySelectorAll('[data-preorder-end][data-badge-label]') : [];
            for (var k = 0; k < badges.length; k++) {
              initSingleTimer(badges[k]);
            }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initPreorderTimers();
      observeNewTimers();
    });
  } else {
    initPreorderTimers();
    observeNewTimers();
  }

  window.initPreorderTimers = initPreorderTimers;
})();
